import { BASE_HEADER_HEIGHT, BASE_ROW_HEIGHT } from './contextMenu/zoom';

const PAGINATION_HEIGHT = 52;
const HEIGHT_PROP_PAGINATION_OFFSET = 49;

export const getRowsTableHeight = (rows: number): number =>
  BASE_HEADER_HEIGHT + rows * BASE_ROW_HEIGHT + PAGINATION_HEIGHT + HEIGHT_PROP_PAGINATION_OFFSET;

const DIALOG_TABLE_CHROME = '2rem + 2px';
const SCROLLBAR_ALLOWANCE = 16;

export const getDialogTableWidth = (columnsWidth: number): string =>
  `calc(${columnsWidth + SCROLLBAR_ALLOWANCE}px + ${DIALOG_TABLE_CHROME})`;
